module.exports = __webpack_public_path__ + "img/info_icon_green.7074e3dd.svg";